// Client form of the backend address rule `MailAddress.TryCreate(value, out var a) && a.Address == value` (.NET 10).
// Locked by mailAddress.contract.spec.ts against the shared corpus generated by scripts/contracts/mail-address-dotnet.mjs.
// Callers reject control characters, including .NET's CR/LF folding. Dot-atoms may end with a dot but not start with one
// or contain "..". The parsed local part and domain are NFC-normalized, so a non-NFC input cannot equal parsed.Address.
const atext = "[A-Za-z0-9!#$%&'*+/=?^_`{|}~\\-\\u{80}-\\u{10FFFF}]"
const dotAtom = `${atext}+(?:\\.${atext}+)*\\.?`
const quoted = '"(?:[\\x01-\\x09\\x0B\\x0C\\x0E-\\x21\\x23-\\x5B\\x5D-\\u{10FFFF}]|\\\\[\\x00-\\x08\\x0B\\x0C\\x0E-\\x1F\\x21-\\u{10FFFF}])*"'
const literal = '\\[(?:[\\x01-\\x09\\x0B\\x0C\\x0E-\\x5A\\x5E-\\x7F]|\\\\[\\x00-\\x08\\x0B\\x0C\\x0E-\\x1F\\x21-\\x7F])*\\]'
const mailAddress = new RegExp(`^(?:${dotAtom}|${quoted})@(?:${dotAtom}|${literal})$`, 'u')

export function isMailAddress(value: string) {
  // .NET normalization refuses unmatched surrogates and U+FFFE; JS normalize alone preserves them.
  return mailAddress.test(value) && !/[\ud800-\udfff\ufffe]/u.test(value) && value.normalize('NFC') === value
}

/** `char.IsControl`: C0, DEL and C1 — wider than the C0/DEL range a browser check usually covers. */
export function hasControlChar(value: string) { return /[\x00-\x1f\x7f-\x9f]/.test(value) }

const dotnetSpace = '[\\t-\\r \\u0085\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000]'
const dotnetEdges = new RegExp(`^${dotnetSpace}+|${dotnetSpace}+$`, 'gu')
/** .NET whitespace only: unlike JavaScript, it includes U+0085 and excludes U+FEFF. */
export function dotnetTrim(value: string) { return value.replace(dotnetEdges, '') }
/** The text the backend validates: the browser trims before sending, then .NET `Trim()` removes its own whitespace set. */
export function serverText(value: string) { return dotnetTrim(value.trim()) }
